export default __webpack_public_path__ + "static/media/svg-7.49586a1f.svg";